import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, concatMap, map, of } from "rxjs";
import {
  loadOrganizationAssignableRoles,
  loadOrganizationAssignableRolesFailure,
  loadOrganizationAssignableRolesSuccess
} from "@organizations/store/actions";
import { OrganizationService } from "@organizations/services";

@Injectable()
export class OrganizationAssignableRoleEffects {
  loadOrganizationAssignableRole$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadOrganizationAssignableRoles),
      concatMap((organizationId) =>
        this.organizationService.getAssignableRoles(organizationId.organizationId).pipe(
          map((role) =>
            loadOrganizationAssignableRolesSuccess({ organizationAssignableRole: role })
          ),
          catchError(() => of(loadOrganizationAssignableRolesFailure()))
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private organizationService: OrganizationService
  ) {}
}
